module.exports = __webpack_public_path__ + "img/EY_thumbnail.ac1ba652.png";